// frontend/src/features/aw/api.js
import api from "../../apiClient";

export async function importAccounts(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await api.post("/aw/import", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });
  return res.data;
}

export async function getAccounts(params = {}) {
  const res = await api.get("/aw/accounts", { params });
  return res.data;
}

export async function getAccount(id) {
  const res = await api.get(`/aw/accounts/${id}`);
  return res.data;
}

export async function updateAccount(id, data) {
  const res = await api.put(`/aw/accounts/${id}`, data);
  return res.data;
}

export async function getAccountDetails(id) {
  const res = await api.get(`/aw/accounts/${id}/details`, { timeout: 180000 });
  return res.data;
}

export async function deleteAccount(id) {
  const res = await api.delete(`/aw/accounts/${id}`);
  return res.data;
}

export async function getStats() {
  const res = await api.get("/aw/stats");
  return res.data;
}

export async function getAssessors() {
  const res = await api.get("/aw/assessors");
  return res.data;
}

// --- Supported CADs ---
export async function getSupportedCads() {
  const res = await api.get("/aw/supported_cads");
  return res.data;
}

// --- Scraping ---
const SCRAPE_TIMEOUT = 5 * 60 * 1000;

export async function scrapeAccounts(payload) {
  const res = await api.post("/aw/scrape", payload, { timeout: SCRAPE_TIMEOUT });
  return res.data;
}

export async function scrapeAll(filters = {}) {
  const res = await api.post("/aw/scrape/all", filters);
  return res.data;
}

export async function getScrapeProgress() {
  const res = await api.get("/aw/scrape/progress");
  return res.data;
}

// --- Pending ---
export async function markPending(id) {
  const res = await api.post(`/aw/accounts/${id}/mark_pending`);
  return res.data;
}

export async function markPendingBatch(ids) {
  const res = await api.post("/aw/accounts/mark_pending_batch", { account_ids: ids });
  return res.data;
}

export async function checkPending(days = 10) {
  const res = await api.post(`/aw/accounts/check_pending?days=${days}`, {}, { timeout: SCRAPE_TIMEOUT });
  return res.data;
}

// --- Schedule ---
export async function getSchedule() {
  const res = await api.get("/aw/schedule");
  return res.data;
}

export async function saveSchedule(config) {
  const res = await api.post("/aw/schedule", config);
  return res.data;
}

// --- Clients & Contacts ---
export async function getClients() {
  const res = await api.get("/aw/clients");
  return res.data;
}

export async function createClient(data) {
  const res = await api.post("/aw/clients", data);
  return res.data;
}

export async function deleteClient(id) {
  const res = await api.delete(`/aw/clients/${id}`);
  return res.data;
}

export async function addContact(clientId, data) {
  const res = await api.post(`/aw/clients/${clientId}/contacts`, data);
  return res.data;
}

export async function deleteContact(id) {
  const res = await api.delete(`/aw/contacts/${id}`);
  return res.data;
}

// --- Agent Config ---
export async function getAgentConfig() {
  const res = await api.get("/aw/agent-config");
  return res.data;
}

export async function addAgentConfig(data) {
  const res = await api.post("/aw/agent-config", data);
  return res.data;
}

export async function deleteAgentConfig(id) {
  const res = await api.delete(`/aw/agent-config/${id}`);
  return res.data;
}

// --- Form Defaults ---
export async function getFormDefaults() {
  const res = await api.get("/aw/form-defaults");
  return res.data;
}

export async function updateFormDefaults(data) {
  const res = await api.put("/aw/form-defaults", data);
  return res.data;
}

export async function importClients(file) {
  const form = new FormData();
  form.append("file", file);
  const res = await api.post("/aw/clients/import", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}
